
const digest = '3269064da4408c66d5199eb7954aaf5e52a46c50e5c6086630d509c425800111';
const classes = {"wrapper":"_wrapper_1llr2_1","timelineWrapper":"_timelineWrapper_1llr2_8","timelinePart":"_timelinePart_1llr2_13","columnsTitle":"_columnsTitle_1llr2_17","timeline":"_timeline_1llr2_8","column":"_column_1llr2_17","title":"_title_1llr2_37","subtitle":"_subtitle_1llr2_43","description":"_description_1llr2_50","legend":"_legend_1llr2_55","legendItem":"_legendItem_1llr2_62","legendItemBubble":"_legendItemBubble_1llr2_69","legendTitle":"_legendTitle_1llr2_76","legendItemTitle":"_legendItemTitle_1llr2_81","haveToFillNow":"_haveToFillNow_1llr2_86","scheduled":"_scheduled_1llr2_90","prescheduled":"_prescheduled_1llr2_90","cantFillNow":"_cantFillNow_1llr2_94","canFillNow":"_canFillNow_1llr2_98","completed":"_completed_1llr2_102","line":"_line_1llr2_106","lineBadge":"_lineBadge_1llr2_114","showMore":"_showMore_1llr2_138","columnDivider":"_columnDivider_1llr2_148","iconWrapper":"_iconWrapper_1llr2_160"};
const css = `._wrapper_1llr2_1 {
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  padding: 24px;
}

._timelineWrapper_1llr2_8 {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
._timelineWrapper_1llr2_8 ._timelinePart_1llr2_13 {
  display: flex;
  flex-direction: column;
}
._timelineWrapper_1llr2_8 ._timelinePart_1llr2_13 ._columnsTitle_1llr2_17 {
  color: #000000;
  font-weight: 500;
  font-size: 16px;
}

._timeline_1llr2_8 {
  display: flex;
  flex-direction: row;
  flex-grow: 1;
}

._column_1llr2_17 {
  padding: 60px 10px 10px 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  position: relative;
}
._column_1llr2_17 ._title_1llr2_37 {
  font-size: 14px;
  color: #97a4ba;
  margin-top: 15px;
  cursor: pointer;
}
._column_1llr2_17 ._subtitle_1llr2_43 {
  font-size: 10px;
  color: #97a4ba;
  text-align: center;
  width: 60px;
}

._description_1llr2_50 {
  font-size: 14px;
  color: #3e3f42;
}

._legend_1llr2_55 {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 10px;
}

._legendItem_1llr2_62 {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0 9px;
}

._legendItemBubble_1llr2_69 {
  width: 10px;
  height: 10px;
  border-radius: 100%;
  margin-right: 5px;
}

._legendTitle_1llr2_76 {
  font-size: 12px;
  color: #9ea0a5;
}

._legendItemTitle_1llr2_81 {
  font-size: 12px;
  color: #3e3f42;
}

._haveToFillNow_1llr2_86 {
  background: rgb(170, 15, 40);
}

._scheduled_1llr2_90, ._prescheduled_1llr2_90 {
  background: #1665d8;
}

._cantFillNow_1llr2_94 {
  background: rgb(98, 98, 98);
}

._canFillNow_1llr2_98 {
  background: rgb(225, 94, 0);
}

._completed_1llr2_102 {
  background: rgb(65, 154, 13);
}

._line_1llr2_106 {
  width: 2px;
  position: absolute;
  top: 0;
  z-index: 1;
  background: #ff0000;
}

._lineBadge_1llr2_114 {
  color: #ffffff;
  background: #062a60;
  padding: 5px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 3px;
  z-index: 2;
  position: absolute;
  top: 15px;
  display: flex;
  justify-content: center;
}
._lineBadge_1llr2_114::after {
  content: "";
  width: 9px;
  height: 5px;
  position: absolute;
  bottom: -5px;
  background-image: url("/dist/icons/react/nowpin.svg");
  background-repeat: no-repeat;
  background-position: center bottom;
}

._showMore_1llr2_138 {
  font-size: 14px;
  color: #1665d8;
  text-decoration: underline;
  padding-right: 20px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

._columnDivider_1llr2_148 {
  width: 5px;
  background: #f2f5f8;
  border-left: 2px solid #eaedf3;
  margin: 0 45px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  padding-bottom: 35px;
  flex: 1;
}
._columnDivider_1llr2_148 ._iconWrapper_1llr2_160 {
  height: 32px;
  width: 32px;
  border-radius: 100%;
  background: #3e3f42;
  padding: 9px;
  display: flex;
  justify-content: center;
  align-content: center;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  